import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  NbDialogService,
  NbMediaBreakpointsService,
  NbThemeService,
} from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";

@Component({
  selector: "ngx-view-image",
  styleUrls: ["./view-image.component.scss"],
  templateUrl: "./view-image.component.html",
})
export class ViewImageComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() header: string;
  @Input() imageURL: string;
  @Input() size?: string;
  @Input() sWidth?: string;
  @Input() sHeight?: string;

  isMobile = false;

  constructor(
    private breakpointService: NbMediaBreakpointsService,
    private themeService: NbThemeService
  ) {
    const { sm } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < sm),
        takeUntil(this.destroy$)
      )
      .subscribe((isLessThanSm: boolean) => {
        this.isMobile = isLessThanSm;
      });
  }

  ngOnInit(): void {
    if (!this.imageURL) this.imageURL = "/assets/images/image-upload-bg.jpg";
    if (!this.header) this.header = "";
    if (!this.size) this.size = "medium";
    if (!this.sWidth) this.sWidth = "100%";
    if (!this.sHeight) this.sHeight = "100%";
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
